import React from 'react';

interface StatsCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  color: 'blue' | 'green' | 'purple' | 'orange';
  subtitle?: string;
  subtitleColor?: string;
  onClick?: () => void;
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, icon, color, subtitle, subtitleColor, onClick }) => {
  return (
    <div
      className={`stats-card ${onClick ? 'stats-card-clickable' : ''}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <div className="stats-card-content">
        <div className="stats-info">
          <p className="stats-title">{title}</p>
          <p className="stats-value">{value}</p>
          {subtitle && (
            <p className="stats-subtitle" style={{ color: subtitleColor || '#10b981' }}>
              {subtitle}
            </p>
          )}
        </div>
        <div className={`stats-icon icon-${color}`}>
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
